module.exports = __webpack_public_path__ + "static/media/registerBg.b8cbbc85.jpg";